module.exports = __webpack_public_path__ + "static/media/banner-clients-02-mobile.f9b966ef.jpg";